// extracted by mini-css-extract-plugin
export var cardIcon = "_5e-4";
export var checkboxCard = "_5e-0";
export var checkboxCardSelected = "_5e-3";
export var disabled = "_5e-1";
export var outerBorder = "_5e-2";
export var spacerMedium = "_5e-7";
export var spacerSmall = "_5e-6";
export var spacerXsmall = "_5e-5";